import React from "react";
import ReactDom from "react-dom";

import JumpNavigation from "./JumpNavigationApp.jsx";
import inPageNavigation from "../../common/inPageNavigation.js";

export default function renderJumpNavigation() {
  const anchors =
    Array.from(document.querySelectorAll(".js-jump-nav-anchor")) || [];

  if (anchors.length <= 0) {
    return;
  }

  document.querySelectorAll(".js-jump-nav-mount").forEach((mount) => {
    const condensed = mount.hasAttribute("data-condensed");
    const label = mount.dataset.label || "";

    let index = 0;

    const links = anchors.reduce((data, anchor) => {
      if (!anchor.textContent) {
        return data;
      }

      const target = anchor.id ? anchor.id : `jump-nav-anchor${index}`;
      anchor.setAttribute("data-index", index);
      anchor.setAttribute("id", target);

      data.push({
        label: anchor.textContent,
        index,
        href: `#${target}`,
        element: anchor,
      });

      index++;

      return data;
    }, []);

    // look for any anchor tags on the page targeting jump links.
    // these links are ignored in the global # check (index.js) due to the targets not having IDs
    inPageNavigation(document.querySelectorAll('a[href*="#jump-nav-anchor"'));

    ReactDom.render(
      <JumpNavigation links={links} condensed={condensed} label={label} />,
      mount,
    );
  });
}
